import { temporarilyNotSupport } from '../../utils'

// 跳转
export const openEmbeddedMiniProgram = /* @__PURE__ */ temporarilyNotSupport('openEmbeddedMiniProgram')
export const navigateToMiniProgram = /* @__PURE__ */ temporarilyNotSupport('navigateToMiniProgram')
export const navigateBackMiniProgram = /* @__PURE__ */ temporarilyNotSupport('navigateBackMiniProgram')
export const exitMiniProgram = /* @__PURE__ */ temporarilyNotSupport('exitMiniProgram')
export const openBusinessView = /* @__PURE__ */ temporarilyNotSupport('openBusinessView')
